<template>
  <div class="tax-section">
    <h6 class="section-label mt-0">
      <feather-icon icon="FileTextIcon" size="13" class="mr-50" />Document Details
    </h6>

    <b-row>
      <b-col md="6">
        <b-form-group class="mb-0">
          <label>Owner Name</label>
          <b-form-input v-model="ownerNameModel" placeholder="e.g. John Doe" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group class="mb-0">
          <label>Agent Name</label>
          <b-form-input v-model="agentNameModel" placeholder="Name of agent preparing this document" />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  components: {
    BRow, BCol, BFormGroup, BFormInput,
  },
  props: {
    ownerName: { type: String, default: null },
    agentName: { type: String, default: null },
  },
  computed: {
    ownerNameModel: {
      get() { return this.ownerName },
      set(value) { this.$emit('update:ownerName', value) },
    },
    agentNameModel: {
      get() { return this.agentName },
      set(value) { this.$emit('update:agentName', value) },
    },
  },
}
</script>
